import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RetriveFormComponent } from './retrive-form.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { MatSortModule } from '@angular/material/sort';
import { RetriveFormRoutingModule } from './retrive-form-routing.module';
import { ExceljsonUploadPopupComponent } from 'src/app/shared/components/exceljson-upload-popup/exceljson-upload-popup.component';

@NgModule({
  declarations: [RetriveFormComponent],
  imports: [
    CommonModule,
    CustomInputModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    MaterialModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    MatSortModule,
    RetriveFormRoutingModule,
 
  ],
  exports: [RetriveFormComponent],
})
export class RetriveFormModule {}
